export const AdAccounts = ['Meta', 'Google Ads', 'LinkedIn', 'Twitter', 'TikTok']